import React, { useEffect, useState, Form } from "react";
import {
  Container,
  Button,
  Row,
  Col,
  Navbar,
  Nav,
  Badge,
} from "react-bootstrap";
import Constants from "../lib/constants";

import Layout from "../components/layout";
import ServerProps from "../lib/serverProps";
import Collapse from "react-bootstrap/Collapse";
import faqController from "../lib/faq/faqController";
import serializable from "../lib/serializable";
import Editable from "../components/Editable";
import ListItemEditor from "../components/ListItemEditor";
import IconButton from "../components/IconButton";
import Global from "../utils/globalEvents";
import pagesController from "../lib/pages/pagesController";
import Access from "../utils/access";
import Api from "../utils/apiCall";
import { useRouter } from "next/router";

const FAQPage = ({ state, types, faqs, page }) => {
  const [open, setOpen] = useState([]);
  const [content, setContent] = useState(faqs);
  const [contentData, setContentData] = useState(faqs);
  const [deletedList, setDeletedList] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [backupData, setBackupData] = useState([...faqs]);
  const sectionIds = ["Generalq", "Questionsabt", "Investors", "Companies"];
  const { user } = state;
  const canEdit =
    user.id && (Access.can("manage", user) || page.UserId === user.id);
  const router = useRouter();
  useEffect(() => {
    let tempOpen = [];
    for (let i = 0; i < faqs.length; i++) {
      tempOpen.push(false);
    }
    setOpen(tempOpen);
  }, []);

  const handleExpand = (index, val) => {
    let copyOpen = open;
    copyOpen[index] = val;
    setOpen([...copyOpen]);
  };

  //fixed side menu
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    function handleScroll() {
      const scrollTop = window.pageYOffset;
      if (scrollTop > 0 && !isSticky) {
        setIsSticky(true);
      } else if (scrollTop === 0 && isSticky) {
        setIsSticky(false);
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isSticky]);

  //end fixed side menu

  //mobile

  const [selectedOption, setSelectedOption] = useState("");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    const section = document.getElementById(event.target.value);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const updateField = (data, category, index, action) => {
    let copyContent = [...contentData];
    let item = { ...copyContent[index] };
    if (action === "delete") {
      let copyDeletedList = deletedList;
      let rest = copyContent.filter((data, i) => {
        if (i !== index) return data;
        else copyDeletedList.push(data.id);
      });
      setContent(rest);
      setContentData(rest);
      setDeletedList(copyDeletedList);
    } else {
      item[category] = data;
      item[action] = true;
      copyContent[index] = item;
      setContentData([...copyContent]);
    }
  };

  const edit = () => {
    Global.dispatch("editmodeHide", true);
    setOpen(open.fill(true, 0, content.length));
    setEditMode(true);
  };

  const cancel = () => {
    setContent(backupData);
    setOpen(open.fill(false, 0, content.length));
    Global.dispatch("editmodeHide", false);
    setEditMode(false);
  };

  const save = async () => {
    try {
      const result = await Api.call("faq", "POST", contentData);
      if (deletedList.length > 0) {
        const deletedResult = await Api.call("faq", "DELETE", deletedList);
      }
      if (result) {
        setOpen(open.fill(false, 0, contentData.length));
        setEditMode(false);
        Global.dispatch("editmodeHide", false);
        setBackupData([...contentData]);
        setContent([...contentData]);
        router.reload();
        window.scrollTo(0, 0);
      }
    } catch (error) {
      console.log(error);
      window.scrollTo(0, 0);
    }
  };

  const addFaq = (id) => {
    let newFaqObj = {
      FAQTypeId: id,
      UserId: user.id,
      answer: "",
      question: "",
      added: true,
    };
    setContent([...contentData, newFaqObj]);
    setContentData([...contentData, newFaqObj]);
  };

  // end mobile
  return (
    <Layout
      title="FAQs"
      meta={{
        card: "summary_large_image",
        description:
          "Read the most common questions and answers about how equity crowdfunding works with Stride Equity.",
      }}
      state={state}
    >
      <div className="funding in-news">
        {canEdit && (
          <Navbar
            className="save-bar bottom-nav-bar"
            fixed="bottom"
            variant="dark"
          >
            <Container className="text-right edit-offer">
              {editMode ? (
                <>
                  <IconButton variant="light" icon="cancel" onClick={cancel}>
                    Cancel
                  </IconButton>{" "}
                  &nbsp;
                  <div>
                    <IconButton
                      variant="outline-info"
                      icon="check"
                      onClick={save}
                    >
                      Save
                    </IconButton>
                  </div>
                </>
              ) : (
                <>
                  <Navbar.Text>
                    <Badge>You can edit this page</Badge>
                  </Navbar.Text>
                  <div className="justify-content-end">
                    <IconButton variant="light" onClick={edit}>
                      Edit
                    </IconButton>
                  </div>
                </>
              )}
            </Container>
          </Navbar>
        )}
        <Container className="content-wrapper faq-page standalone-pages">
          <Row>
            <Col md={12}>
              <h2 className="main-title">FAQs</h2>
              <hr className="black-line" />
            </Col>
            <Col md={6} sm={12}>
              <div className={`wrap-faq-nav ${isSticky ? "sticky" : ""}`}>
                <Navbar className="faq-nav p-0">
                  <Nav.Link href="#Generalq">General Questions</Nav.Link>
                  <Nav.Link href="#Questionsabt">
                    Questions about Stride Equity
                  </Nav.Link>
                  <Nav.Link href="#Investors">For Investors</Nav.Link>
                  <Nav.Link href="#Companies">For Companies</Nav.Link>
                </Navbar>
              </div>
            </Col>

            <Col className="add-padding-col" md={6} sm={12}>
                <div
                  className={`faq-mb-drop ${isSticky ? "sticky" : ""} form-group`}
                >
                  <label className="form-label"></label>
                  <select
                    className="form-control"
                    value={selectedOption}
                    onChange={handleOptionChange}
                  >
                    <option value="Generalq">General Questions</option>
                    <option value="Questionsabt">
                      Questions about Stride Equity
                    </option>
                    <option value="Investors">For Investors</option>
                    <option value="Companies">For Companies</option>
                  </select>
                </div>
              {types.map((type, tIndex) => {
                return (
                  <div className="wrap-section">
                    <section key={tIndex} id={sectionIds[tIndex]}>
                      <h3 className="faq-title space-no">{type.name}</h3>
                      <hr />
                      {content.map((data, index) => {
                        if (data.FAQTypeId == type.id) {
                          return (
                            <>
                              {editMode ? (
                                <>
                                  <div
                                    className="text"
                                    style={{ alignSelf: "flex-end" }}
                                  >
                                    <div className="edit-text">
                                      <Editable
                                        edit={editMode}
                                        value={data?.question}
                                        update={(val) =>
                                          updateField(
                                            val,
                                            "question",
                                            index,
                                            data?.id ? "updated" : "added"
                                          )
                                        }
                                        placeholder="question"
                                      />
                                    </div>
                                  </div>
                                  <br />
                                </>
                              ) : (
                                <Button
                                  onClick={() =>
                                    handleExpand(index, !open[index])
                                  }
                                  aria-controls="example-collapse-text"
                                  aria-expanded={open}
                                  className={`btn-collaps ${open[index] ? "active" : ""
                                    }`}
                                >
                                  <>
                                    <div
                                      className="editor-content editor-pages"
                                      dangerouslySetInnerHTML={{
                                        __html: data?.question,
                                      }}
                                    />
                                    <svg
                                      width="30px"
                                      height="30px"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M12 14.5C11.9015 14.5005 11.8038 14.4813 11.7128 14.4435C11.6218 14.4057 11.5392 14.3501 11.47 14.28L8 10.78C7.90861 10.6391 7.86719 10.4715 7.88238 10.3042C7.89756 10.1369 7.96848 9.97954 8.08376 9.85735C8.19904 9.73515 8.352 9.65519 8.51814 9.63029C8.68428 9.6054 8.85396 9.63699 9 9.72003L12 12.72L15 9.72003C15.146 9.63699 15.3157 9.6054 15.4819 9.63029C15.648 9.65519 15.801 9.73515 15.9162 9.85735C16.0315 9.97954 16.1024 10.1369 16.1176 10.3042C16.1328 10.4715 16.0914 10.6391 16 10.78L12.5 14.28C12.3675 14.4144 12.1886 14.4931 12 14.5Z"
                                        fill="#000000"
                                      />
                                    </svg>
                                    <Collapse in={open[index]}>
                                      <div id="example-collapse-text">
                                        <div
                                          className="editor-content editor-pages"
                                          dangerouslySetInnerHTML={{
                                            __html: data?.answer,
                                          }}
                                        />
                                      </div>
                                    </Collapse>
                                  </>
                                </Button>
                              )}

                              {editMode && (
                                <>
                                  <ListItemEditor
                                    options="p b h2 h3 li img left center right a"
                                    content={data?.answer}
                                    update={(val) =>
                                      updateField(
                                        val,
                                        "answer",
                                        index,
                                        data?.id ? "updated" : "added"
                                      )
                                    }
                                  />
                                  <IconButton
                                    variant="primary"
                                    className="btn-dark mt-3 mb-2"
                                    icon="check"
                                    onClick={() => {
                                      updateField(null, "", index, "delete");
                                    }}
                                  >
                                    Delete
                                  </IconButton>
                                </>
                              )}
                              <hr />
                            </>
                          );
                        }
                      })}
                      {editMode && (
                        <IconButton
                          variant="primary"
                          onClick={() => addFaq(type.id)}
                        >
                          Add an FAQ
                        </IconButton>
                      )}
                    </section>
                  </div>
                );
              })}
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res }) {
  const faqTypes = await faqController.getTypes();
  const faqs = await faqController.find();
  const page = await pagesController.findById("faq");

  return {
    props: {
      state: await ServerProps.getState(req),
      types: serializable(faqTypes),
      faqs: serializable(faqs),
      page: serializable(page),
    },
  };
}

export default FAQPage;
